<template>
    <form id="email-change-form" class="form account-settings" @submit.prevent="handleSubmit" @keydown.enter.prevent="handleSubmit">
        <h4 class="w-100 sm-fs-sm"> Mobile phone (for 2FA) </h4>
        <small v-if="errors && errors.General" class="text-danger">{{ Array.isArray(errors.General) ? errors.General.join('. ') : errors.General }}</small>
        <div class="w-full d-flex gap-3 align-items-end">
            <PhoneField type="tel" label="Verified Phone number" placeholder="x (xxx) xxx-xxxx" :max=17 v-model:modelValue="phone" />
            <button type="submit" class="btn toggle-control lh-sm" :class="{'btn-primary': !isButtonDisabled, 'btn-secondary': isButtonDisabled}" :disabled="isButtonDisabled"> Update </button>
        </div>
    </form>
  </template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue';
import { useModalStore } from '@/stores/modal';
import { useParticipantStore } from '@/stores/participant';
import PhoneField from '@components/form/PhoneField.vue';
import axios from 'axios';
import { computed } from 'vue';

export default defineComponent({
    components: {
        PhoneField,
    },

    setup() {
        const modalStore = useModalStore();
        const participantStore = useParticipantStore();
        const errors = ref<Record<string, string>>({ General: '' });
        const success = ref('');
        const phone = ref<string>(participantStore.userPhone ?? '');
        const preferedMethod = computed(() => participantStore.userTwoFaMethod)
        const isButtonDisabled = ref(true);

        watch(() => useParticipantStore().userPhone, () => {
            phone.value = useParticipantStore().userPhone ?? '';
        })

        watch(() => phone.value, (newValue) => {
            const cleanedPhoneNumber = newValue.replace(/[()\s-]/g, '');

            if(cleanedPhoneNumber !== useParticipantStore().userPhone) {
                focusButton(false);
            } else {
                focusButton(true);
            }
        })

        // Focus/activate button when typing in specific input
        const focusButton = (state: boolean) => {
            isButtonDisabled.value= state;
        }

        const validatePhoneNumber = (number: string) => {
            const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            errors.value.General = 'Invalid phone number. Please check and ensure it meets the required validation criteria.';

            if(number === useParticipantStore().userPhone) {
                errors.value.General = 'Phone number should be different from the old one.';
                return false;
            }

            return number.length > 10 && number.length <= 17;
        }

        const handleSubmit = () => {
            if (!isButtonDisabled.value && validatePhoneNumber(phone.value)) {
                errors.value.General = '';

                useModalStore().openModal(
                    'validate-user-2fa',
                    'Validate Phone Number',
                    'modal-success',
                    null,
                    {
                        onConfirm: () => {
                            submitData();
                            useModalStore().closeAbove(0);
                            focusButton(true);
                        }
                    },
                    null,
                    null,
                    {phone: phone.value, method: 'P'}
                );
            }
        }

        const submitData = async () => {
            const formData = {
                phone: phone.value,
            };

            axios.post('api/user/settings', { ...formData, _method: 'PATCH' })
                .then(response => {
                    success.value = response.data.success;
                    errors.value = { General: '' };

                    setTimeout(() => {
                        success.value = '';
                    }, 3500);

                    modalStore.openModal(
                        "success-modal",
                        null,
                        "modal-success",
                        null,
                        {
                            title: "Updated Successfully",
                            content: {
                                type: "text",
                                value: 'Your Phone number has been updated successfully!',
                                icon: "iatse-icon-user-verified"
                            },
                            onConfirmButton: "Close",
                            onConfirm: () => {
                                participantStore.getUserEmail();
                            },
                        },);
                })
                .catch((error: any) => {
                    if (error.response) {
                        errors.value = error.response.data.errors;
                    }
                })
                .finally(() => {
                    setTimeout(() => {
                        if(errors.value && errors.value?.General) {
                            errors.value.General = '';
                        }
                    }, 3500);
                })
        };

        return {
            success,
            errors,
            phone,
            isButtonDisabled,
            preferedMethod,
            handleSubmit,

        };
    },
});
</script>
